/**
 * Created by spepa on 01.11.2022
 */

const UnitLibraryIconFooter = cc.Node.extend({
    ctor: function (unit, collectReward) {
        this._super();
        this.unit = unit;
        this.collectReward = collectReward;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(cleverapps.styles.UnitLibraryIconFooter);

        if (!cleverapps.meta.getSelectedLocation().locationConfig.hideUnitLibraryLevel) {
            this.createLevel();
        }
    },

    createLevel: function () {
        const styles = cleverapps.styles.UnitLibraryIconFooter;

        if (styles.level === false) {
            return;
        }

        this.level = cleverapps.UI.generateOnlyText(this.generateLevelTxT(), cleverapps.styles.FONTS.UNITICON_LEVEL);
        this.level.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        this.level.fitTo(styles.width, styles.height);
        this.level.setAlignment(this.width / 2, this.height / 2);
        this.addChild(this.level);
    },

    generateLevelTxT: function () {
        let levelText = "UnitLibraryIcon.level";

        const family = Families[this.unit.code];
        if (this.unit.stage === family.units.length - 1) {
            levelText = "UnitLibraryIcon.level.max";
        }

        const stage = this.unit.stage + 1;

        levelText = Messages.get(levelText, {
            level: stage
        });

        if (levelText.length > 10) {
            levelText = cleverapps.splitHalfByWord(levelText).join("\n");
        }

        if (family.type === "valuables" && family.units[this.unit.stage].value) {
            levelText += `\n(${family.units[this.unit.stage].value})`;
        }

        return levelText;
    },

    updateStatus: function () {
        if (cleverapps.unitsLibrary.isFresh(this.unit)) {
            this.level && this.level.setVisible(false);
            this.createCollectBtn();
        } else {
            if (this.collectButton) {
                this.collectButton.removeFromParent();
                delete this.collectButton;
            }
            this.level && this.level.setVisible(true);
        }
    },

    createCollectBtn: function () {
        if (this.collectButton) {
            return;
        }

        const styles = cleverapps.styles.UnitLibraryIconFooter.collectButton;
        this.collectButton = new cleverapps.UI.Button({
            text: Messages.get("Collect"),
            width: styles.width,
            height: styles.height,
            type: styles.type,
            onClicked: this.collectReward
        });
        this.addChild(this.collectButton);
        this.collectButton.setAlignment(this.width / 2, this.height / 2);
    }
});

cleverapps.styles.UnitLibraryIconFooter = {
    width: 220,
    height: 80,

    collectButton: {
        width: 200,
        height: 80,
        type: cleverapps.styles.UI.Button.Images.button_green
    }
};